export default "__VITE_ASSET__CUKTutHV__"